import { render, staticRenderFns } from "./FaqEditor.vue?vue&type=template&id=3dfb954e&scoped=true&"
import script from "./FaqEditor.vue?vue&type=script&lang=js&"
export * from "./FaqEditor.vue?vue&type=script&lang=js&"
import style0 from "./FaqEditor.vue?vue&type=style&index=0&id=3dfb954e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb954e",
  null
  
)

export default component.exports